<template>
  <div class="signUp">
    <div class="tc">
      <el-image
        :src="logo"
        class="image cursor"
        @click="$router.push('/')"
      ></el-image>
    </div>
    <div class="subtitle">—— {{ $t("innovationCooperation") }} ——</div>
    <div
      class="loginContent"
      :class="LOCALE == 'en' ? 'enTabs' : 'zhTabs'"
      v-if="!isSignUp"
    >
      <div class="moudle" v-if="IS_EN">
        <signUp
          :signType="'email'"
          @successChange="successChange"
          @getLoading="btnLoadingChange"
        >
          <el-button
            slot="footerBtn"
            type="primary"
            class="loginBut"
            size="small"
            :loading="emailLoading"
          >
            {{ $t("immedRegister") }}</el-button
          ></signUp
        >
      </div>
      <el-tabs v-model="activeName" class="tabs" v-else>
        <el-tab-pane :label="$t('phoneSign')" name="first">
          <div class="moudle">
            <signUp
              @successChange="successChange"
              @getLoading="btnLoadingChange"
            >
              <el-button
                slot="footerBtn"
                type="primary"
                class="loginBut"
                size="small"
                :loading="btnLoading"
                >{{ $t("immedRegister") }}</el-button
              >
              <el-button
                slot="footerBtn1"
                type="primary"
                class="loginBut"
                size="small"
                >{{ $t("next") }}</el-button
              >
            </signUp>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('emailSign')" name="second">
          <div class="moudle">
            <signUp
              :signType="'email'"
              @successChange="successChange"
              @getLoading="btnLoadingChange"
            >
              <el-button
                slot="footerBtn"
                type="primary"
                class="loginBut"
                size="small"
                :loading="emailLoading"
              >
                {{ $t("immedRegister") }}</el-button
              ></signUp
            >
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="fr">
        {{ $t("hasAccount") }}，<span class="mainColor cursor" @click="toSign">
          {{ $t("emailAladyTip2") }}></span
        >
      </div>
    </div>
    <div v-else class="SignUpBox">
      <div class="SignUpBoxContent">
        <i class="el-icon-success SignUpIcon mainColor"></i>
        <div style="margin-left: 10px; padding-top: 8px">
          <div class="tip_header">{{ $t("registerSuccess") }}</div>
          <div class="goLogin mainColor" @click="toSign">
            {{ $t("emailAladyTip2") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import signUp from "~/baseComponents/baseSign/signUp";
export default {
  components: { signUp },
  data() {
    return {
      activeName: "first",
      isSignUp: false,
      btnLoading: false,
      emailLoading: false,
      logo: "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/expo/logo1.png",
    };
  },
  methods: {
    btnLoadingChange(val) {
      if (this.activeName == "first") {
        this.btnLoading = val;
      } else {
        this.emailLoading = val;
      }
    },
    successChange() {
      this.isSignUp = true;
    },
    toSign() {
      this.$router.push("/sign");
    },
  },
};
</script>
<style lang="less" scoped>
.signUp {
  width: 470px;
  padding: 0 40px;
  .image {
    width: 320px;
  }
  .subtitle {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    min-height: 30px;
    margin: 30px 0;
    line-height: 25px;
  }
  .loginContent {
    // margin-top: 30px;
    .loginBut {
      width: 390px;
      display: block;
      height: 40px;
      margin: 24px auto 12px;
      border: 0 none;
      font-size: 16px;
    }
  }
  .SignUpBox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 200px;
    .SignUpBoxContent {
      display: flex;
      .SignUpIcon {
        font-size: 60px;
      }
    }
    .tip_header {
      font-weight: 600;
      font-size: 14px;
    }
    .goLogin {
      margin-top: 8px;
      cursor: pointer;
      font-weight: 600;
    }
    .small {
      font-size: 14px;
    }
  }
  .moudle {
    margin-top: 10px;
  }
}
</style>